module.exports = __webpack_public_path__ + "static/media/iconCantineActive.717d947a.svg";